import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import poActions from '../actions/purchaseOrder';

function getPurchaseOrder(store) {
    request.get(`/${config.url_prefix}/api/getPurchaseOrder?site=${store.getState().system.siteName}`)
        .responseType('blob')
        .end((error, res) => {
            if (error) {
                const errorKey = 'ipmob.internal.server.error';
                store.dispatch(poActions.getPurchaseOrderError(errorKey));
                store.dispatch(actions.enableLoadOverLay(false));
            } else {
                const file = new Blob(
                    [res.body],
                    {type: 'application/pdf'});
                const fileURL = URL.createObjectURL(file);
                store.dispatch(poActions.getPurchaseOrderSuccess(fileURL, file));
                store.dispatch(actions.enableLoadOverLay(false));
            }
        });
}

export default getPurchaseOrder;
